export const JOB_TYPE_OPTIONS = [
  { value: 'mo', label: 'MO' },
  { value: 'job', label: 'Job' },
  { value: 'stock', label: 'Stock' },
  { value: 'other', label: 'Other' }
];

export const getJobTypeFromJobNumber = (jobNumber) => {
  if (!jobNumber || typeof jobNumber !== 'string') {
    return null;
  }

  const normalizedJobNumber = jobNumber.toUpperCase();

  if (normalizedJobNumber.startsWith('MO')) return 'mo';
  if (normalizedJobNumber.startsWith('20')) return 'job';
  if (normalizedJobNumber.startsWith('99')) return 'stock';
  return 'other';
};
